import { Link } from "react-router";

import { Tag } from "../lib/Tag.tsx";
import { NOTIFICATIONS_COPY, TONE_TAGS } from "./notifications.constants.ts";
import type { NotificationRow as Row } from "./notifications.model.ts";

/**
 * One row: what it is, what it is about, and the one thing you can do with it.
 *
 * ONE action, and it always navigates. Answering happens on the screen that owns
 * the act — the Verifications card with its evidence, its capacities and its
 * composers — so that there is one place a name gets put to something rather
 * than two that must agree about when it may be.
 */
export function NotificationRow({ row, onOpen }: { row: Row; onOpen: () => void }) {
  return (
    <li
      className={`notifications__row notifications__row--${row.chip.tone} ${
        row.read ? "" : "notifications__row--unread"
      }`}
    >
      <div className="notifications__body">
        <p className="notifications__head">
          <Tag tone={TONE_TAGS[row.chip.tone]}>{row.chip.label}</Tag>
          <span className="notifications__title">{row.title}</span>
          {!row.read && (
            <span className="notifications__new">{NOTIFICATIONS_COPY.unread}</span>
          )}
        </p>

        <p className="notifications__detail">{row.detail}</p>

        {(row.subject ?? row.from) && (
          <p className="notifications__meta">
            {row.subject && <span>{row.subject}</span>}
            {row.from && <span>{row.from}</span>}
          </p>
        )}
      </div>

      <div className="notifications__aside">
        <time dateTime={row.isoTime} className="notifications__when">
          {row.when}
        </time>
        <Link to={row.action.href} className="notifications__action" onClick={onOpen}>
          {row.action.label}
        </Link>
      </div>
    </li>
  );
}
